module.exports = __webpack_public_path__ + "img/stars.2d69a0a6.png";